import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
}

export const Root = styled.div`
  font-family: Roboto;
  margin-top:6px;
  width: auto;
  display: flex;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
`;

export const Label = styled.label`
  margin-top: 15px;
  margin-bottom: 16px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.WHITE};
  display: flex;
`;